import {useSelector} from "react-redux";

import AccessError from "../AccessError";
import accessDenied_light from "assets/images/accessDenied_light.png";
import accessDenied_dark from "assets/images/accessDenied_dark.png";

const GenericError = ({customButton}: {customButton?: React.ReactNode}) => {
  const {
    userInfo: {
      settings: {darkMode},
    },
  } = useSelector((state: any) => state.stateUserInfo);
  return (
    <AccessError
      type="Erro desconhecido"
      title="Erro desconhecido"
      message="Ocorreu um erro desconhecido. Por favor, tente novamente mais tarde 
      ou contate o suporte."
      imageSrc={darkMode ? accessDenied_dark : accessDenied_light}
      customButton={customButton}
    />
  );
};

export default GenericError;
